import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  Pagination,
  IconButton,
  InputAdornment,
  TextField,
  Avatar,
  Skeleton,
} from "@mui/material";
import {
  Work,
  LocationOn,
  People,
  Search,
  Business,
  SettingsOutlined,
  LocationOnOutlined,
  BusinessCenterOutlined,
} from "@mui/icons-material";
import { ROUTINGDATA } from "../../ROUTINGDATA";
import { useNavigate } from "react-router-dom";
import { CurrentStateContext } from "../../../App";
import useAxios from "../../../api/useAxios";
import employerdefaultimg from "../../../img/employer/empUpdateProfileLogo.png";

export default function CompanyList() {
  const [employerList, setEmployerList] = useState([]);
  const [page, setPage] = useState(1);
  const itemsPerPage = 12;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const totalPages = (totalCount = employerList.length) => {
    return Math.ceil(totalCount / itemsPerPage);
  };
  const navigate = useNavigate();
  const { baseUrl, axiosData, customBreakpoints } =
    useContext(CurrentStateContext);
  const handlePageChange = (event, value) => {
    setPage(value);
  };
  // <!----GET--->
  const fetchApi = async () => {
    try {
      const useAxiosData = await axiosData.get("employers");
      const { data } = useAxiosData;
      if (useAxiosData.status === 204) {
        setEmployerList([]);
      } else {
const result = data
  .filter(item => item.status === "A" && (item.job_count || 0) >= 1)
  .sort((a, b) => (b.job_count || 0) - (a.job_count || 0));


        setEmployerList(result);
        setTotalPage(totalPages(result.length));
        setIsLoaded(true);
      }
      // setGetApi(data);
      // getFilterValue(filterName.status, filterName.date, data);
      // setLoading({ ...loading, isLoading: false });
    } catch (err) {
      console.log("Error", err);
    }
  };
  const getCurrentPageEmployers = () => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return employerList.slice(startIndex, endIndex);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchApi();

    // handleSort(sortedData);
  }, []);

  return (
    <Box sx={{ bgcolor: "#f5f7fa", minHeight: "100vh", py: 4 }}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box
          sx={{
            mb: 4,
            display: "flex",
            flexDirection: customBreakpoints.isMobileDown ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box width={"100%"}>
            <Typography
              variant="h4"
              sx={{ fontFamily: "Poppins-SemiBold" }}
              color="text.primary"
              gutterBottom
            >
              Find Your Future Workplace
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Find the dream companies you dream work for. All companies where
              you can build your bright future
            </Typography>
          </Box>
          <Box width={customBreakpoints.isMobileDown ? "100%" : "296px"}>
            {/* Search Bar */}
            {/* <TextField
              fullWidth
              placeholder="Search"
              variant="outlined"
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "28px",
                  borderColor: "#BFBFBF",
                  paddingRight: "9px",
                  width: "100%",

                  "&:hover fieldset": {
                    borderColor: "#BFBFBF",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#BFBFBF",
                  },
                },
                "& .MuiInputBase-root": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#BFBFBF",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#404040", // Light gray placeholder text
                    opacity: 1, // Ensures the placeholder is fully visible
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: "text.secondary" }} />
                  </InputAdornment>
                ),
              }}
            /> */}
          </Box>
        </Box>

        {/* Job Cards Grid */}
        <Grid container spacing={3}>
          {!isLoaded
            ? Array.from({ length: 12 }, (_, i) => i).map((i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: 2,
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      "&:hover": {
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        transform: "translateY(-2px)",
                        transition: "all 0.3s ease",
                      },
                    }}
                  >
                    {/* Gradient Header */}
                    <Box
                      sx={{
                        height: 60,
                        background:
                          "linear-gradient(135deg, #005E82 13%, #EC2172 100%)",
                        borderRadius: "8px 8px 0 0",
                        position: "relative",
                      }}
                    >
                      {/* Logo */}
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: -25,
                          left: 16,
                          width: 60,
                          height: 60,
                          bgcolor: "white",
                          borderRadius: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          border: "2px solid white",
                        }}
                      >
                        {/* <img
                          src={
                            job.logoUpload
                              ? `${baseUrl}employers/logo/email/${job.email_id}/Admin`
                              : employerdefaultimg
                          }
                          alt="logo"
                          width={60}
                          height={60}
                        /> */}
                        {/* <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{
                        background: job.gradient,
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontSize: job.logo === "TCS" ? "16px" : "20px",
                      }}
                    >
                      {job.logo}
                    </Typography> */}
                      </Box>
                    </Box>

                    <CardContent sx={{ pt: 4, pb: 2, flexGrow: 1 }}>
                      {/* Company Name */}
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={230}
                        height={40}
                        sx={{ borderRadius: "15px" }}
                      />
                      {/* Job Details */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Skeleton
                            animation="wave"
                            variant="text"
                            width={230}
                            height={40}
                            sx={{ borderRadius: "15px" }}
                          />
                        </Box>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Skeleton
                            animation="wave"
                            variant="text"
                            width={230}
                            height={40}
                            sx={{ borderRadius: "15px" }}
                          />
                        </Box>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Skeleton
                            animation="wave"
                            variant="text"
                            width={230}
                            height={40}
                            sx={{ borderRadius: "15px" }}
                          />
                        </Box>
                      </Box>

                      {/* View Jobs Button */}
                      <Button
                        variant="outlined"
                        fullWidth
                        disabled={!isLoaded}
                        sx={{
                          mt: "auto",
                          textTransform: "none",
                          borderColor: "#1976d2",
                          color: "#1976d2",
                          "&:hover": {
                            borderColor: "#1565c0",
                            bgcolor: "rgba(25, 118, 210, 0.04)",
                          },
                        }}
                      >
                        View Jobs
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            : getCurrentPageEmployers().map((job) => (
                <Grid item xs={12} sm={6} md={4} key={job.id}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: 2,
                      boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
                      "&:hover": {
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        transform: "translateY(-2px)",
                        transition: "all 0.3s ease",
                      },
                    }}
                  >
                    {/* Gradient Header */}
                    <Box
                      sx={{
                        height: 60,
                        background:
                          "linear-gradient(135deg, #005E82 13%, #EC2172 100%)",
                        borderRadius: "8px 8px 0 0",
                        position: "relative",
                      }}
                    >
                      {/* Logo */}
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: -25,
                          left: 16,
                          width: 60,
                          height: 60,
                          bgcolor: "white",
                          borderRadius: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          border: "2px solid white",
                        }}
                      >
                        <img
                          src={
                            job.logoUpload
                              ? `${baseUrl}employers/logo/email/${job.email_id}/Admin`
                              : employerdefaultimg
                          }
                          alt="logo"
                          width={60}
                          height={60}
                        />
                        {/* <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{
                        background: job.gradient,
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontSize: job.logo === "TCS" ? "16px" : "20px",
                      }}
                    >
                      {job.logo}
                    </Typography> */}
                      </Box>
                    </Box>

                    <CardContent
                      sx={{
                        pt: 4,
                        pb: 2,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* Company Name */}
                      <Typography
                        variant="h6"
                        fontWeight="600"
                        sx={{
                          mb: 2,
                          fontSize: "1rem",
                          fontFamily: "Poppins-SemiBold",
                        }}
                      >
                        {job.company_name}
                      </Typography>

                      {/* Job Details */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <SettingsOutlined
                            sx={{ fontSize: 16, color: "text.secondary" }}
                          />
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontFamily: "Poppins-SemiBold" }}
                          >
                            {job.industry}
                          </Typography>
                        </Box>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <LocationOnOutlined
                            sx={{ fontSize: 16, color: "text.secondary" }}
                          />
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontFamily: "Poppins-SemiBold" }}
                          >
                            {job.district}
                          </Typography>
                        </Box>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <BusinessCenterOutlined
                            sx={{ fontSize: 16, color: "text.secondary" }}
                          />
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontFamily: "Poppins-SemiBold" }}
                          >
                            {`Job available ${job?.job_count ?? 0}`}
                          </Typography>
                        </Box>
                      </Box>

                      {/* View Jobs Button */}
                      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                          variant="outlined"
                          fullWidth
                          sx={{
                            mt: "auto",
                            textTransform: "none",
                            borderColor: "#005E82",
                            color: "#005E82",
                            "&:hover": {
                              borderColor: "#005E82",
                              bgcolor: "rgba(25, 118, 210, 0.04)",
                            },
                            width: "137px",
                            height: "44px",
                            borderRadius: "8px",
                            fontFamily: "Poppins-Medium",
                          }}
                          onClick={() => {
                            navigate(
                              `${ROUTINGDATA.LAND}${ROUTINGDATA.MAIN}${ROUTINGDATA.company}`,
                              { state: { email_id: job.email_id } }
                            );
                          }}
                        >
                          View Jobs
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
        </Grid>
        {/* {Array.from({ length: 12 }, (_, i) => i)} */}
        {/* Pagination */}
        {isLoaded ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <Pagination
              count={totalPage}
              page={page}
              onChange={handlePageChange}
              color="primary"
              sx={{
                "& .MuiPaginationItem-root": {
                  "&.Mui-selected": {
                    bgcolor: "#006989",
                    "&:hover": {
                      bgcolor: "#005070",
                    },
                  },
                },
              }}
            />
          </Box>
        ) : null}
      </Container>
    </Box>
  );
}
